module.exports = __webpack_public_path__ + "static/media/beat-heart-monitor-svgrepo-com.8f62513f.svg";